// Prepare step based on provided config

import VueFormGenerator from "vue-form-generator";
import { get_validator_messages } from "../validators/locale_pl";
import { isValidPESEL } from "../validators/pesel";
import { isValidNip } from "../validators/nip";
import { getPikadayOptions } from "../utils/pikaday_options";
import { Conditions } from "../steps/conditions.js";
import { FillInTheField } from "../steps/fill_field.js";

var validator_messages = get_validator_messages();

var DEFAULT_FORM_SCHEMA = {
  groups: []
};

var DEFAULT_FROM_GROUP = {
  styleClasses: "form-row"
};
export class Step {
  constructor(config) {
    this.config = config;
  }
  // return step actions
  get actions() {
    return this.config.actions;
  }

  get add_multiple() {
    return this.config.add_multiple;
  }

  // return form schema, we have to modify provided schema
  // in a config as there are additional actions needed
  get form_schema() {
    var schema = JSON.parse(JSON.stringify(DEFAULT_FORM_SCHEMA));
    // iterate over group of fields
    if (this.config.schema == null) return null;
    this.config.schema.forEach(function(config_group) {
      var group = Object.assign(config_group, DEFAULT_FROM_GROUP);
      // have to iterate over each field to add default options
      // and make some modifications if needed
      var fields = [];
      group.fields.forEach(function(field_config) {
        // iterate over validators and modify them based on the validator type
        if (field_config.validator) {
          var validators = [];
          field_config.validator.forEach(function(validator) {
            var validator_object = null;
            // string validator
            if (validator == "string") {
              validator_object = VueFormGenerator.validators.string.locale(
                validator_messages
              );
            } else if (validator == "email") {
              validator_object = VueFormGenerator.validators.email.locale(
                validator_messages
              );
            } else if (validator == "required") {
              validator_object = VueFormGenerator.validators.required.locale(
                validator_messages
              );
            } else if (validator == "number") {
              validator_object = VueFormGenerator.validators.number.locale(
                validator_messages
              );
            } else if (validator == "double") {
              validator_object = VueFormGenerator.validators.double.locale(
                validator_messages
              );
            } else if (validator == "date") {
              validator_object = VueFormGenerator.validators.date.locale(
                validator_messages
              );
            } else if (validator == "array") {
              validator_object = VueFormGenerator.validators.array.locale(
                validator_messages
              );
            } else if (validator == "pesel") {
              validator_object = VueFormGenerator.validators.pesel = function(
                value
              ) {
                if (!isValidPESEL(value) && value != false && value != null) {
                  return ["Niepoprawny pesel"];
                }
              };
            } else if (validator == "nip") {
              validator_object = VueFormGenerator.validators.nip = function(
                value
              ) {
                if (!isValidNip(value) && value != false && value != null) {
                  return ["Niepoprawny nip"];
                }
              };
            }
            if (validator_object) {
              validators.push(validator_object);
            }
          });
          field_config.validator = validators;
        }

        // check if there are any visibility conditions
        if (field_config.visible_if || field_config.fill_data) {
          field_config.visible = function() {
            var conditions = new Conditions(
              field_config.visible_if,
              this.model
            );
            var visible = conditions.is_all_valid;
            if (visible && field_config.fill_data) {
              new FillInTheField(field_config, this.model);
            }
            return visible;
          };
        }

        // if field is a pikaday - add some default options
        if (field_config.type == "pikaday") {
          field_config.pikadayOptions = getPikadayOptions();
        }

        fields.push(field_config);
      });
      group.fields = fields;
      schema.groups.push(group);
    });
    return schema;
  }

  // return header of the step
  get header() {
    return this.config.header;
  }

  // return footer of the step
  get footer() {
    return this.config.footer;
  }

  // return help data of the step
  get help() {
    return this.config.help;
  }
  get schema_classes() {
    return this.config.schema_classes;
  }
  // return title_page data of the step
  get title_page() {
    return this.config.title_page;
  }

  // return true if progress bar should be showed
  get show_progress_bar() {
    if (this.config == null) return false;

    if (this.config.show_progress_bar == null) {
      return true;
    } else {
      return this.config.show_progress_bar;
    }
  }
}
